import { useIntl } from 'react-intl';
import getOpCoRoutes from 'getOpCoRoutes';

const routes = getOpCoRoutes();

function GetRouteByName(name) {
  const { locale } = useIntl();
  return routes[locale][name];
}

function getRouteByNameAndLanguage(name, language) {
  return routes[language][name];
}

export { getRouteByNameAndLanguage };
export default GetRouteByName;
